import {Injectable} from '@angular/core';
import {ResultatData} from '../shared/models/resultat-data.model';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResultatStoreService {
  private readonly state: ResultatData = {
    resultatDtos: [],
    resultatSummaDto: {
      summaInkomstSEK: 0,
      summaMaximalAvrakning: 0
    }
  };

  get resultatData(): ResultatData {
    return this._resultatData.getValue();
  }

  set resultatData(val: ResultatData) {
    this._resultatData.next(val);
  }

  private readonly _resultatData: BehaviorSubject<ResultatData> = new BehaviorSubject<ResultatData>(this.state);

  update(resultatData: ResultatData): void {
    this.resultatData = resultatData;
  }

  clearAll(): void {
    this.resultatData = this.state;
  }
}
